import React from "react";

const SvgCurriculumVitae = props => (
    <svg width="1em" height="1em" viewBox="0 0 43.916 43.916" {...props}>
        <path
            d="M34.395 0H9.522a5 5 0 0 0-5 5v33.916a5 5 0 0 0 5 5h24.871a5 5 0 0 0 5-5V5a4.999 4.999 0 0 0-4.998-5zM9.208 16.855c0-1.172.951-2.121 2.121-2.121h.742a4.906 4.906 0 0 1-1.277-3.304 4.932 4.932 0 0 1 9.864.001 4.899 4.899 0 0 1-1.279 3.303h.709a2.12 2.12 0 0 1 2.121 2.121v3.578c0 1.122-.875 2.03-1.975 2.106h-9.051a2.115 2.115 0 0 1-1.975-2.106v-3.578zm23.5 20.561h-21.5a2 2 0 0 1 0-4h21.5a2 2 0 0 1 0 4zm0-7.5h-21.5a2 2 0 0 1 0-4h21.5a2 2 0 0 1 0 4zm0-7.5h-6.5a2 2 0 0 1 0-4h6.5a2 2 0 0 1 0 4z"
            fill={props.color}
        />
    </svg>
);

export default SvgCurriculumVitae;
